define([], function() {
    return function (value, fillNum) {
        fillNum=fillNum ? fillNum : 2;
        var temp=""+value;
        while(temp.length<fillNum) temp="0"+temp;
        return temp;
    };
});

